module.exports = __webpack_public_path__ + "img/incein-feetCombination.b6ae2c36.svg";